// @flow
import * as React from 'react';

import { Link } from '@i18n';
import { INDEX } from '@routes';

import { StyledLogo, StyledLogoWrapper } from './styles';

const CurefyLinkLogo = () => (
  <Link href={INDEX} passHref>
    <StyledLogoWrapper>
      <StyledLogo src="../../../../../static/images/curefy-logo.png" alt="Curefy Logo" />
    </StyledLogoWrapper>
  </Link>
);

export default CurefyLinkLogo;
